import { createAsyncThunk } from '@reduxjs/toolkit';
import { notification } from 'antd';
import { fetchApiAuth } from 'core/utils/api';
import { handleError } from 'core/utils/helpers';
import { BookingShiftType, BookingSite, BookingWorkType, GenerateBookingLinkPayload } from './types';

export const fetchBookingFormData = createAsyncThunk(
    'bookingLinks/formData',
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetchApiAuth({
                method: 'GET',
                url: 'booking-links/form-data',
            });

            return response.data.sites as BookingSite[];
        } catch (error: unknown) {
            const errorMessage = handleError(error);
            if (errorMessage !== false) {
                notification.error({ message: 'Error', description: errorMessage });
                return rejectWithValue(errorMessage);
            }
            throw error;
        }
    },
);

export const fetchSiteWorkTypes = createAsyncThunk(
    'bookingLinks/siteWorkTypes',
    async (siteId: number, { rejectWithValue }) => {
        try {
            const response = await fetchApiAuth({
                method: 'GET',
                url: `booking-links/sites/${siteId}/work-types`,
            });

            return response.data.workTypes as BookingWorkType[];
        } catch (error: unknown) {
            const errorMessage = handleError(error);
            if (errorMessage !== false) {
                notification.error({ message: 'Error', description: errorMessage });
                return rejectWithValue(errorMessage);
            }
            throw error;
        }
    },
);

export const fetchSiteShiftTypes = createAsyncThunk(
    'bookingLinks/siteShiftTypes',
    async (siteId: number, { rejectWithValue }) => {
        try {
            const response = await fetchApiAuth({
                method: 'GET',
                url: `booking-links/sites/${siteId}/shift-types`,
            });

            return response.data.shiftTypes as BookingShiftType[];
        } catch (error: unknown) {
            const errorMessage = handleError(error);
            if (errorMessage !== false) {
                notification.error({ message: 'Error', description: errorMessage });
                return rejectWithValue(errorMessage);
            }
            throw error;
        }
    },
);

export const generateBookingLink = createAsyncThunk(
    'bookingLinks/generate',
    async (payload: GenerateBookingLinkPayload, { rejectWithValue }) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: 'booking-links',
                body: payload,
            });

            notification.success({
                message: 'Success',
                description: 'Booking link sent to the guest.',
            });

            return response.data;
        } catch (error: unknown) {
            const errorMessage = handleError(error);
            if (errorMessage !== false) {
                notification.error({ message: 'Error', description: errorMessage });
                return rejectWithValue(errorMessage);
            }
            throw error;
        }
    },
);
